var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg2385229281579605846(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#4d91bb;}.cls-2{fill:#7aaccc;}.cls-3{fill:#2175aa;}.cls-4{fill:#f2f2f2;}.cls-5{fill:#f7f7f7;}.cls-6{fill:#e6e6e6;}.cls-7{fill:#333;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "12 Student Card") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_12_Student_Card",
    "data-name": "12 Student Card"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16,
    y: 32,
    width: 96,
    height: 64,
    rx: 6,
    ry: 6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16.41,38.41a6,6,0,0,1,6-6h84a6,6,0,0,1,4,1.56A6,6,0,0,0,106,32H22a6,6,0,0,0-6,6c0,56.6-.75,54,2,56.44C15.81,92.06,16.41,94.55,16.41,38.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M109,32.82c1.14,2,.82-1.67.82,55a6,6,0,0,1-6,6c-90.65,0-85,.35-87-.82A6,6,0,0,0,22,96h84a6,6,0,0,0,6-6V38A6,6,0,0,0,109,32.82Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 16,
    y: 40,
    width: 96,
    height: 48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 16,
    y: 40,
    width: 0.41,
    height: 48
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M109.83,87.83c0,.06,0,.11,0,.17H112V40h-2.17Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 38.31,
    cy: 64,
    r: 14
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M100.72,72.49H64a2,2,0,0,1,0-4h36.74A2,2,0,0,1,100.72,72.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M100.72,59.51H64a2,2,0,0,1,0-4h36.74A2,2,0,0,1,100.72,59.51Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2385229281579605846);
export default __webpack_public_path__ + "static/media/2385229281579605846.d10963a7.svg";
export { ForwardRef as ReactComponent };